import { sliceActions } from "./reducer";

const AppActions = { ...sliceActions };
export default AppActions;
